// Formats a money amount the way App\View\Components\Price does on the server:
// pence shown only when they are non-zero, so a round amount reads "£109" rather
// than "£109.00".
//
// Exists because the booking panels teleport their own totals into a pop-out
// footer and so have to format prices client-side, where <x-price> cannot reach.
// ProductCard.vue formats through it too.
//
// Returns null for a null/undefined/non-numeric amount, so callers can withhold
// the whole row instead of rendering "£0" or "£NaN" for a price that is simply
// not known yet.
export function formatPrice(amount) {
    if (amount === null || amount === undefined || amount === '') {
        return null;
    }

    // JSON can carry a price as a string ("109.00"), so coerce before testing.
    const value = Number(amount);

    if (Number.isNaN(value)) {
        return null;
    }

    const precision = value % 1 === 0 ? 0 : 2;

    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
    }).format(value);
}
